import { render, staticRenderFns } from "./yx-comment-preview.vue?vue&type=template&id=75fdd009&scoped=true&"
import script from "./yx-comment-preview.vue?vue&type=script&lang=js&"
export * from "./yx-comment-preview.vue?vue&type=script&lang=js&"
import style0 from "./yx-comment-preview.vue?vue&type=style&index=0&id=75fdd009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fdd009",
  null
  
)

export default component.exports